(function () {
  "use strict";

  var e = {
    175: function _(e, r, t) {
      var u = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };

      Object.defineProperty(r, "__esModule", {
        value: !0
      }), r.isHex = r.padHexStart = r.ensureBuffer = r.hash160 = r.ripemd160 = r.sha256 = r.bech32 = r.base58 = void 0;
      var f = u(t(768)),
          n = u(t(390));
      r.base58 = n.default;
      var i = u(t(848));

      function o(e) {
        return !!e.match(/([0-9]|[a-f])/gim) && Buffer.from(e, "hex").toString("hex") === e.toLowerCase();
      }

      function s(e) {
        if (Buffer.isBuffer(e)) return e;

        switch (typeof e) {
          case "string":
            e = o(e) ? Buffer.from(e, "hex") : Buffer.from(e);
            break;

          case "object":
            e = Buffer.from(JSON.stringify(e));
        }

        return !!Buffer.isBuffer(e) && e;
      }

      function a(e, r) {
        return (0, f.default)(e, s(r)).toString("hex");
      }

      r.bech32 = i.default, r.isHex = o, r.ensureBuffer = s, r.hash160 = function (e) {
        return a("hash160", e);
      }, r.sha256 = function (e) {
        return a("sha256", e);
      }, r.ripemd160 = function (e) {
        return a("ripemd160", e);
      }, r.padHexStart = function (e, r) {
        var t = 2 * r || e.length;
        return t += t % 2, e.padStart(t, "0");
      };
    },
    848: function _(e) {
      e.exports = require("bech32");
    },
    390: function _(e) {
      e.exports = require("bs58");
    },
    768: function _(e) {
      e.exports = require("crypto-hashing");
    }
  },
      r = {},
      t = function t(u) {
    var f = r[u];
    if (void 0 !== f) return f.exports;
    var n = r[u] = {
      exports: {}
    };
    return e[u].call(n.exports, n, n.exports, t), n.exports;
  }(175);

  module.exports = t;
})();